<template>
  <details class="simple" open>
    <summary>Tabla de Productividad Comercial</summary>

    <div class="mb-2 mt-3" style="max-width: 300px">
      <b-form-input v-model="filter" type="search" placeholder="Búsqueda rápida"></b-form-input>
    </div>

    <b-table
      :items="items"
      :fields="fields"
      :filter="filter"
      striped
      hover
      responsive
      show-empty
      empty-text="No hay datos disponibles"
      foot-clone
      foot-variant="dark"
    >
      <template #cell(comercial)="data">
        <strong>{{ data.item.comercial }}</strong>
      </template>

      <template #cell(ganadas)="data">
        {{ data.item.ganadas }}
      </template>

      <template #cell(productividad)="data">
        <b-badge :variant="getProductividadVariant(data.item.productividad)">
          {{ data.item.productividad | fraction }} %
        </b-badge>
      </template>

      <template #cell(ARR)="data">
        {{ data.item.ARR | euro }}
      </template>

      <template #cell(contribucionARR)="data"> {{ data.item.contribucionARR | fraction }} % </template>

      <template #cell(ultimaVenta)="data">
        {{ data.item.ultimaVenta | dateEs }}
      </template>

      <!-- Footer con el resumen -->
      <template #foot(comercial)>
        <strong>{{ totalFilas }} Filas</strong>
      </template>

      <template #foot(ganadas)>
        <span class="item-resumen">{{ totalGanadas }} Ganadas</span>
      </template>

      <template #foot(totalOfertas)>
        <span class="item-resumen">{{ totalOfertas }} Total</span>
      </template>

      <template #foot(productividad)>
        <span class="item-resumen">{{ mediaDiasGestion | fraction }} Días</span>
      </template>

      <template #foot(ARR)>
        <span class="item-resumen">{{ totalARR | euro }}</span>
      </template>

      <template #foot(ultimaVenta)>
        <span class="item-resumen">{{ ultimaVentaGlobal | dateEs }}</span>
      </template>
    </b-table>
  </details>
</template>

<script>
export default {
  name: "TablaAnalisisComercial",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalFilas() {
      return this.items.length;
    },
    totalGanadas() {
      return this.items.reduce((sum, item) => sum + item.ganadas, 0);
    },
    totalOfertas() {
      return this.items.reduce((sum, item) => sum + item.totalOfertas, 0);
    },
    mediaDiasGestion() {
      if (this.items.length === 0) return 0;
      const totalDias = this.items.reduce((sum, item) => sum + item.promedioGanadas, 0);
      return totalDias / this.items.length;
    },
    totalARR() {
      return this.items.reduce((sum, item) => sum + item.ARR, 0);
    },
    ultimaVentaGlobal() {
      if (this.items.length === 0) return null;
      return this.items.reduce((latest, item) => {
        const itemDate = new Date(item.ultimaVenta);
        return itemDate > new Date(latest) ? item.ultimaVenta : latest;
      }, this.items[0].ultimaVenta);
    },
  },

  data() {
    return {
      filter: "",
      fields: [
        {
          key: "comercial",
          label: "Comercial",
          sortable: true,
        },
        {
          key: "ganadas",
          label: "Ganadas",
          sortable: true,
          class: "text-center",
        },
        {
          key: "totalOfertas",
          label: "Total",
          sortable: true,
          class: "text-center",
        },
        {
          key: "productividad",
          label: "Productividad",
          sortable: true,
          class: "text-center",
        },
        {
          key: "ARR",
          label: "Importe",
          sortable: true,
          class: "text-right",
        },
        {
          key: "contribucionARR",
          label: "Contribución",
          sortable: true,
          class: "text-right",
        },
        {
          key: "ultimaVenta",
          label: "Última venta",
          sortable: true,
          class: "text-right",
        },
      ],
    };
  },

  methods: {
    getProductividadVariant(productividad) {
      if (productividad >= 10) return "success";
      if (productividad >= 5) return "warning";
      return "danger";
    },
  },
};
</script>

<style scoped>
.tabla-analisis-comercial {
  margin-top: 1rem;
}
.item-resumen {
  font-weight: bold;
}
</style>
